import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const CookiePolicyPage = () => {
  return (
    <main className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
          Cookie Policy
        </h1>
        <p className="text-gray-600 mb-8">Last updated: January 2026</p>

        <Card>
          <CardContent className="p-8 prose prose-emerald max-w-none">
            <h2>1. What Are Cookies?</h2>
            <p>
              Cookies are small text files that are stored on your device when you visit a website. 
              They help the website remember your preferences and improve your browsing experience.
            </p>

            <h2>2. How We Use Cookies</h2>
            <p>Flippy Homes uses cookies for the following purposes:</p>
            
            <h3>Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function properly. They enable core 
              functionality such as security, network management, and accessibility.
            </p>

            <h3>Performance Cookies</h3>
            <p>
              These cookies help us understand how visitors interact with our website by collecting 
              and reporting information anonymously. This helps us improve our services.
            </p>

            <h3>Functionality Cookies</h3>
            <p>
              These cookies allow the website to remember choices you make (such as your preferred 
              language or region) and provide enhanced, more personal features.
            </p>

            <h3>Marketing Cookies</h3>
            <p>
              These cookies are used to track visitors across websites. The intention is to display 
              ads that are relevant and engaging for the individual user.
            </p>

            <h2>3. Types of Cookies We Use</h2>
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2 text-left">Cookie Name</th>
                  <th className="border border-gray-300 p-2 text-left">Purpose</th>
                  <th className="border border-gray-300 p-2 text-left">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-2">session_id</td>
                  <td className="border border-gray-300 p-2">User authentication</td>
                  <td className="border border-gray-300 p-2">Session</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">preferences</td>
                  <td className="border border-gray-300 p-2">User preferences</td>
                  <td className="border border-gray-300 p-2">1 year</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">analytics</td>
                  <td className="border border-gray-300 p-2">Website analytics</td>
                  <td className="border border-gray-300 p-2">2 years</td>
                </tr>
              </tbody>
            </table>

            <h2>4. Managing Cookies</h2>
            <p>
              You can control and/or delete cookies as you wish. You can delete all cookies that 
              are already on your computer and you can set most browsers to prevent them from being placed.
            </p>
            <p>
              To manage cookies in your browser:
            </p>
            <ul>
              <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies</li>
              <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Cookies</li>
              <li><strong>Edge:</strong> Settings → Privacy → Cookies</li>
            </ul>

            <h2>5. Third-Party Cookies</h2>
            <p>
              Some cookies are placed by third-party services that appear on our pages. We do not 
              control the dissemination of these cookies. Please check the third-party websites 
              for more information about their cookies.
            </p>

            <h2>6. Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time. Any changes will be posted on 
              this page with an updated revision date.
            </p>

            <h2>7. Contact Us</h2>
            <p>
              If you have questions about our use of cookies, please contact us at:<br/>
              Email: privacy@flippyhomes.co.za<br/>
              WhatsApp: +27 65 524 9286
            </p>
          </CardContent>
        </Card>
      </div>
    </main>
  );
};

export default CookiePolicyPage;
